import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

import Input from '../../../../../components/input';
import { USERAPI } from '../../../../../../../services/api';

class Password extends React.PureComponent {
    static propTypes = {
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        value: PropTypes.string,
        error: PropTypes.bool,
        onKeydown: PropTypes.func,
    };

    state = {};

    render() {
        const { onChange, onBlur, value, error } = this.props;
        const config = {
            onChange,
            onBlur,
            value,
            error,
        };

        return (
            <div className={styles.password}>
                <div className={styles.input}>
                    <Input type={'password'} {...config} placeholder={'密码'} onKeydown={this.props.onKeydown} />
                </div>
                <a href={`${USERAPI}/findpass`} target="_blank" className={styles.loginregi}>
                    忘记密码？
                </a>
            </div>
        );
    }
}

export default errorBoundary(Password);
